/**
 * @param {string} string
 * @returns {string|undefined}
 */
function decodeEntities (string) {
  if (!string) return

  return string
    .toString()
    .replace(/&amp;/g, '&')
}

module.exports = { decodeEntities }
